import { useState, useEffect } from "react";
import PercentageCircle from "components/PercentageCircle/PercentageCircle";
import { Button, ButtonType } from "components/Button/Button";
import { MOBILE_WIDTH } from "utils/constants";
import "./PlayerSidebar.scss";

const PlayerSidebar = ({ sectionsArray, selectedSection, handleClickSectionItem, submodule, module, courseLink }) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_WIDTH);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < MOBILE_WIDTH);
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const title = () => {
		if (submodule) {
			return submodule.Name;
		} else {
			return module.Name;
		}
	};

	const renderItems = () => {
		if (!sectionsArray || sectionsArray.length === 0) {
			return <p>This content has no sections</p>;
		}
		return sectionsArray.map((section) => (
			<div
				key={section.id}
				className={`player-sidebar-item ${section.id === selectedSection ? "selected" : ""}`}
				onClick={() => handleClickSectionItem(section.id)}
			>
				<div className="player-sidebar-item-button">
					<PercentageCircle progress={section.visited ? 100 : 0} size={50} visited={/*Boolean for if the content is classes as visited*/ false} />
				</div>
				<div className="player-sidebar-item-details">
					<h4>{section.title}</h4>
				</div>
			</div>
		));
	};

	const renderReturnButton = () => {
		if (!courseLink || !module) {
			return null;
		}
		return (
			<div className="player-sidebar-return">
				<Button
					type={ButtonType.Primary}
					text="Return to Module"
					to={`/course-view#courseId-${courseLink.Id}-moduleId-${module.Id}`}
					flipped
				/>
			</div>
		);
	};

	if (isMobile) {
		return (
			<div className="player-sidebar player-sidebar--mobile">
				<div className="player-sidebar-items">
					{renderItems()}
				</div>
				{renderReturnButton()}
			</div>
		);
	}

	return (
		<div className="player-sidebar">
			<div className="player-sidebar-header">
				<h1>{title()}</h1>
			</div>
			<div className="player-sidebar-items">
				{renderItems()}
			</div>
		</div>
	);
};

export default PlayerSidebar;
